const home = {
  // Hero
  hero_headline_1: 'La Leadership di cui la tua',
  hero_headline_family: 'Famiglia',
  hero_headline_and: 'e la tua',
  hero_headline_school: 'Scuola',
  hero_headline_2: 'hanno bisogno',
  hero_description: 'Trasforma le tue relazioni familiari e la gestione educativa con metodologie comprovate da <strong>17 anni di esperienza</strong>. Scopri il percorso verso una leadership che genera risultati reali e duraturi.',
  hero_btn_books: 'Libri',
  hero_btn_courses: 'Corsi',
  hero_btn_mentorship: 'Mentoria SÍLEX',
  hero_stat_experience: 'Anni di Esperienza',
  hero_stat_mba: 'USP/Esalq',

  // Books section
  books_title: 'Libri e Opere:',
  books_title_highlight: 'L\'Inizio della Trasformazione',
  books_subtitle: 'Libri ed e-book che hanno già trasformato migliaia di famiglie e professionisti dell\'istruzione in tutto il Brasile',
  books_format: 'E-book PDF',
  books_btn_buy: 'Acquista',
  books_btn_details: 'Vedi Dettagli',
  books_guarantee: 'Garanzia 7 giorni',
  books_coming_soon: 'Prossimamente',
  books_coming_new: 'Nuovo titolo prossimamente',
  books_coming_desc: 'Stiamo preparando altri contenuti incredibili per te!',
  books_notify_label: 'Avvisami al lancio',
  books_details_hover: 'Vedi Dettagli',

  // Courses section
  courses_title: 'Formazione d\'Élite:',
  courses_title_highlight: 'Il Metodo Completo',
  courses_subtitle: 'Corsi online strutturati con metodologie validate da oltre 17 anni di esperienza pratica',
  courses_badge: 'Corso Online',
  courses_modules: 'moduli',
  courses_btn_enroll: 'Iscriviti Ora',
  courses_btn_details: 'Vedi Dettagli',
  courses_guarantee: 'Garanzia 30 giorni',
  courses_coming_new: 'Nuovo corso prossimamente',
  courses_coming_desc: 'Stiamo preparando una nuova formazione incredibile per te!',
  courses_students: 'studenti',
  courses_or: 'o',
  courses_hover_view: 'Vedi Corso',
  courses_testimonials_title: 'Cosa Dicono i Nostri Studenti',

  // SÍLEX Showcase (Vitrine SÍLEX na Home) — i18n: PT provisório (traduzir)
  silex_showcase_eyebrow: 'Método SÍLEX · 48 etapas',
  silex_showcase_title: 'Mentoria',
  silex_showcase_title_highlight: 'SÍLEX',
  silex_showcase_subtitle: 'Para pais e educadores que decidiram parar de disputar atenção — e começar a reconstruir presença, respeito e direção.',
  silex_showcase_body: 'Um método de cinco pilares para substituir o ruído dos confrontos pela clareza do diálogo, instalando uma aliança de respeito mútuo e engajamento prático entre pais, educadores e jovens.',
  silex_showcase_benefits_kicker: 'O que você recebe',
  silex_showcase_benefit_1_title: 'Método completo em 48 etapas',
  silex_showcase_benefit_1_desc: 'As 48 etapas do método, do diagnóstico à consolidação. Presente nos três planos, sem versão reduzida.',
  silex_showcase_benefit_2_title: 'Liberação por conclusão, não por calendário',
  silex_showcase_benefit_2_desc: 'Cada etapa abre quando a anterior é concluída. Você avança no seu ritmo, sem pular fundamento.',
  silex_showcase_benefit_3_title: 'Lives coletivas com o mentor',
  silex_showcase_benefit_3_desc: 'Três no Spark, seis no Lab, quinzenais no Protag. Encontros ao vivo para tirar dúvidas e ver o método aplicado a casos reais.',
  silex_showcase_benefit_4_title: 'Encontros individuais',
  silex_showcase_benefit_4_desc: 'Dois no Lab, de dois a quatro no Protag. Sessões reservadas ao seu cenário específico.',
  silex_showcase_benefit_5_title: 'Suporte no canal do seu plano',
  silex_showcase_benefit_5_desc: 'Pela plataforma no Spark, em grupo no Lab, direto no WhatsApp no Protag.',
  silex_showcase_benefit_6_title: 'Acesso por tempo definido',
  silex_showcase_benefit_6_desc: '90 dias no Spark, 180 no Lab, 365 no Protag. Compra única, sem assinatura e sem renovação automática.',
  silex_showcase_cta_secondary: 'Ver planos e detalhes',
  silex_showcase_plans_kicker: 'Conheça os três planos',
  silex_showcase_plan_spark_name: 'SÍLEX Spark',
  silex_showcase_plan_spark_price: 'R$ 997',
  silex_showcase_plan_spark_duration: '90 dias',
  silex_showcase_plan_spark_tagline: 'Começar com clareza',
  silex_showcase_plan_lab_name: 'SÍLEX Lab',
  silex_showcase_plan_lab_price: 'R$ 2.997',
  silex_showcase_plan_lab_duration: '180 dias',
  silex_showcase_plan_lab_tagline: 'Implementar com consistência',
  silex_showcase_plan_protag_name: 'SÍLEX Protag',
  silex_showcase_plan_protag_price: 'R$ 8.997',
  silex_showcase_plan_protag_duration: '365 dias',
  silex_showcase_plan_protag_tagline: 'O caminho principal',
  silex_showcase_plan_protag_highlight: 'Recomendado',
  silex_showcase_plan_duration_label: 'de acesso',
  silex_showcase_plan_card_cta: 'Ver detalhes',
  silex_showcase_plans_note: 'Opções de parcelamento disponíveis no checkout.',
  silex_showcase_guarantee_title: 'Garantia SÍLEX de Clareza e Aplicação',
  silex_showcase_guarantee_text: 'Sete dias para verificar se a estrutura faz sentido para o seu contexto. Se não fizer, o cancelamento é seu direito, sem burocracia.',
  silex_showcase_cta_primary: 'Conhecer a Mentoria SÍLEX',

  // Action Center
  action_title: 'Il Tuo Passo Successivo:',
  action_title_highlight: 'Centro Azione',
  action_subtitle: 'Scegli il percorso ideale per la tua trasformazione',
  action_quick_title: 'Avvio Rapido',
  action_quick_desc: 'Inizia oggi con i nostri e-book e trasforma la tua gestione',
  action_quick_btn: 'Vedi Libri',
  action_deep_title: 'Formazione Completa',
  action_deep_desc: 'Padroneggia tutte le strategie con i nostri corsi strutturati',
  action_deep_btn: 'Vedi Corsi',
  action_deep_badge: 'PIÙ POPOLARE',
  action_elite_title: 'Accesso Elite',
  action_elite_desc: 'Mentorship esclusiva per risultati straordinari',
  action_faq_title: 'Domande Frequenti',
  action_faq_q1: 'Come funziona l\'accesso ai corsi?',
  action_faq_a1: 'Dopo l\'acquisto, ricevi accesso immediato e a vita al contenuto completo per studiare al tuo ritmo.',
  action_faq_q2: 'Gli e-book sono fisici o digitali?',
  action_faq_a2: 'Tutti i nostri libri sono in formato PDF digitale, consentendo accesso immediato dopo l\'acquisto.',
  action_faq_q3: 'Qual è la differenza tra corsi e mentorship?',
  action_faq_a3: 'I corsi sono contenuti strutturati per l\'apprendimento autonomo. La mentorship è un accompagnamento personalizzato ed esclusivo.',
  action_faq_q4: 'C\'è una garanzia di soddisfazione?',
  action_faq_a4: 'Sì! Offriamo 7 giorni di garanzia per gli e-book e 30 giorni per i corsi. Se non sei soddisfatto, rimborsiamo il tuo investimento.',
  action_faq_q5: 'Come funziona il processo di candidatura per la mentorship?',
  action_faq_a5: 'Dopo aver compilato il modulo, il nostro team analizza il tuo profilo e ti contatta entro 24 ore per programmare una conversazione.',
  action_cta_title: 'Pronto a Trasformare la Tua Leadership?',
  action_cta_desc: 'Unisciti ai professionisti che hanno già trasformato la loro vita con i nostri metodi',
  action_cta_btn_explore: 'Esplora i Prodotti',

  // Social Proof
  social_title: 'Contenuto Esclusivo su Instagram',
  social_subtitle: 'Segui contenuti sulla gestione educativa e le relazioni familiari',
  social_follow: 'Segui Ora',

  // Footer
  footer_partner_label: 'Projeto parceiro',
  footer_partner_name: 'Protocolo & Conexão',
  footer_partner_desc: 'Palestras e formações para escolas, famílias e empresas.',
  footer_partner_cta: 'Conhecer o projeto',
  footer_brand_desc: 'Trasformando leader educativi e famiglie attraverso metodologie comprovate da oltre 17 anni.',
  footer_products_title: 'Prodotti',
  footer_products_books: 'Libri ed E-book',
  footer_products_courses: 'Corsi Online',
  footer_products_talks: 'Conferenze Aziendali',
  footer_products_webinars: 'Webinar in Diretta',
  footer_company_title: 'Azienda',
  footer_company_about: 'Chi Siamo',
  footer_company_contact: 'Contatto',
  footer_support_title: 'Supporto',
  footer_support_help: 'Centro Assistenza',
  footer_support_privacy: 'Informativa sulla Privacy',
  footer_support_terms: 'Termini di Utilizzo',
  footer_support_refund: 'Parlare di rimborso',
  footer_copyright: '© {{ano}} SB Family & Mastery. Tutti i diritti riservati.',
  footer_secure: 'Sito Sicuro',
  footer_payment: 'Pagamento Protetto',

  // FAQ Page
  faq_badge: 'Centro Assistenza',
  faq_title: 'Come possiamo aiutarti?',
  faq_subtitle: 'Trova risposte alle domande più comuni sulla piattaforma, corsi, pagamenti e certificati.',
  faq_cat_geral: 'Generale',
  faq_cat_acesso: 'Accesso e Account',
  faq_cat_cursos: 'Corsi',
  faq_cat_pagamento: 'Pagamento',
  faq_cat_certificado: 'Certificati',
  faq_cat_mentoria: 'Mentorship',
  faq_not_found_title: 'Non hai trovato quello che cercavi?',
  faq_not_found_desc: 'Il nostro team di supporto è disponibile dal lunedì al venerdì, dalle 8 alle 18.',
  faq_not_found_btn: 'Parla con il Supporto',

  // Cursos Page
  cursos_badge: 'Programmi d\'Élite',
  cursos_title: 'Catalogo dei',
  cursos_title_highlight: 'Corsi',
  cursos_subtitle: 'Metodologie comprovate per trasformare la tua gestione educativa e le relazioni familiari.',
  cursos_stat_courses: 'corsi disponibili',
  cursos_stat_rating: 'Valutazione media 4.8',
  cursos_stat_guarantee: 'Garanzia 30 giorni',
  cursos_search_placeholder: 'Cerca corsi...',
  cursos_filter_all_areas: 'Tutte le Aree',
  cursos_filter_all_levels: 'Tutti i Livelli',
  cursos_filter_all_durations: 'Qualsiasi Durata',
  cursos_filter_clear: 'Cancella',
  cursos_results_found_one: 'corso trovato',
  cursos_results_found_many: 'corsi trovati',
  cursos_results_none: 'Nessun corso trovato',
  cursos_no_results_title: 'Nessun risultato trovato',
  cursos_no_results_desc: 'Prova ad aggiustare i filtri o a cercare con parole diverse.',
  cursos_no_results_btn: 'Cancella Filtri',
  cursos_badge_online: 'Corso Online',
  cursos_modules_label: 'moduli',
  cursos_enroll_btn: 'Iscriviti Ora',
  cursos_details_btn: 'Vedi Dettagli',
  cursos_view_btn: 'Vedi Corso',
  cursos_cta_title: 'Vuoi Risultati Più Rapidi?',
  cursos_cta_desc: 'La Mentorship Premium è il modo più diretto per trasformare la tua scuola o famiglia con un accompagnamento personalizzato.',
  cursos_students_label: 'studenti',
  cursos_or_label: 'o',

  // Sobre Page
  sobre_badge: 'Chi Siamo',
  sobre_title: '17 anni a formare leader che trasformano',
  sobre_subtitle: 'SB Family & Mastery è nata dalla convinzione che la vera leadership inizia a casa e si espande alle istituzioni. Siamo una piattaforma di educazione esecutiva con una missione chiara: trasformare famiglie e scuole attraverso una conoscenza applicabile.',
  sobre_mission_label: 'La Nostra Missione',
  sobre_vision_label: 'La Nostra Visione',
  sobre_purpose_label: 'Il Nostro Scopo',
  sobre_mission_text: 'Dotare leader educativi e familiari di strumenti pratici e metodologie comprovate che generino una trasformazione reale e misurabile nella vita di persone e istituzioni.',
  sobre_vision_text: 'Essere il principale riferimento nell\'educazione esecutiva per la gestione familiare e scolastica in Brasile, formando una generazione di leader che costruiscono eredità durature.',
  sobre_purpose_text: 'Crediamo che ogni famiglia rafforzata e ogni scuola ben gestita produca onde di impatto positivo che attraversano le generazioni. Ecco perché facciamo quello che facciamo.',
  sobre_values_title: 'I Nostri Valori',
  sobre_values_desc: 'I pilastri che guidano ogni decisione, ogni contenuto e ogni interazione del nostro team.',
  sobre_team_badge: 'Chi c\'è dietro',
  sobre_team_title: 'Il Nostro Team Fondatore',
  sobre_team_desc: 'Professionisti con solida esperienza combinata in educazione, psicologia e tecnologia.',
  sobre_timeline_title: 'Il Nostro Percorso',
  sobre_timeline_desc: '17 anni di storia, apprendimento e impatto.',
  sobre_cta_title: 'Fai parte della trasformazione',
  sobre_cta_desc: 'Unisciti alle famiglie ed educatori che hanno già scelto di crescere con SB Family & Mastery.',
  sobre_cta_contact: 'Contattaci',

  // Contato Page
  contato_badge: 'Contattaci',
  contato_title: 'Siamo qui per aiutarti',
  contato_subtitle: 'Il nostro team di supporto risponde entro 24 ore lavorative. Scegli il canale più comodo per te.',
  contato_form_title: 'Invia un messaggio',
  contato_form_desc: 'Compila il modulo e ti risponderemo entro 24 ore lavorative.',
  contato_name_label: 'Nome completo *',
  contato_email_label: 'E-mail *',
  contato_subject_label: 'Oggetto',
  contato_message_label: 'Messaggio *',
  contato_send_btn: 'Invia Messaggio',
  contato_sending: 'Invio in corso...',
  contato_success_title: 'Messaggio inviato!',
  contato_success_desc: 'Il nostro team ti risponderà entro 24 ore lavorative.',
  contato_success_new: 'Invia un nuovo messaggio',
  contato_error: 'Errore nell\'invio. Riprova o usa un altro canale.',
  contato_faq_title: 'Domande Rapide',
  contato_faq_desc: 'La tua domanda potrebbe essere già risposta nel nostro FAQ:',
  contato_faq_all: 'Vedi tutto il Centro Assistenza',
  contato_hours_title: 'Orari di Assistenza',
  contato_online: 'Supporto online ora',
  contato_hours_weekday: 'Lunedì – Venerdì',
  contato_hours_weekday_val: '8 alle 18',
  contato_hours_saturday: 'Sabato',
  contato_hours_saturday_val: '9 alle 13',
  contato_hours_sunday: 'Domenica e Festivi',
  contato_hours_sunday_val: 'Chiuso',
};

export default home;
